import { call, put, takeEvery } from 'redux-saga/effects';
import { SubscriptionType } from '../actions/action.creator';
import { subscriptionService } from '../../../services/subscriptions';
import { setProcessLoading } from '../../../../../store/action';
import {
    cancelSubscriptionFailure,
    cancelSubscriptionSuccess,
    getAllSubscriptionFailure,
    getSingleSubscription,
    getSingleSubscriptionFailure,
    getSingleSubscriptionSuccess,
    setAllSubscriptions
} from '../actions/action';

export function* getSubscriptions({ payload: value }) {
    yield put(setProcessLoading(true));
    const response = yield call(subscriptionService.getSubscriptions, value);

    if (response.isRight()) {
        yield put(setProcessLoading(false));
        yield put(setAllSubscriptions(response.value.getValue()));
    } else {
        const error = response.value;
        yield put(getAllSubscriptionFailure(error));
    }
}

export function* getSubscriptionsById({ payload: value }) {
    yield put(setProcessLoading(true));
    const response = yield call(subscriptionService.getSubscriptionById, value);

    if (response.isRight()) {
        yield put(setProcessLoading(false));
        yield put(getSingleSubscriptionSuccess(response.value.getValue()));
    } else {
        yield put(setProcessLoading(false));
        yield put(getSingleSubscriptionFailure(response.value));
    }
}

export function* callCancelSubscription({ payload: value }) {
    const response = yield call(subscriptionService.cancelSubscription, value);

    if (response.isRight()) {
        yield put(cancelSubscriptionSuccess(response.value.getValue()));
    } else {
        yield put(cancelSubscriptionFailure(response.value));
    }
}

export function* watchGetSubscriptions() {
    yield takeEvery<any>(SubscriptionType.GET_SUBSCRIPTIONS, getSubscriptions);
}

export function* watchGetSubscriptionById() {
    yield takeEvery<any>(SubscriptionType.GET_SINGLE_SUBSCRIPTION, getSubscriptionsById);
}

export function* watchCancelSubscription() {
    yield takeEvery<any>(SubscriptionType.CANCEL_SUBSCRIPTION, callCancelSubscription);
}
